<template>
    <div class="activities">
        <div v-if="is_ready">

            <div class="form-group mt-3">
                <input type="text" class="form-control" placeholder="Search" v-model="filters.q">
            </div>

            <div class="table-responsive">
                <table class="table table-hover">
                    <tbody>
                    <tr v-for="activity in filtered_activities">
                        <td>
                            <strong>{{ activity.name }}</strong>
                            <div class="small text-muted">{{ activity.data.description }}</div>
                        </td>
                        <td>
                            <button class="btn btn-primary"
                                    @click="select(activity)">
                                + Add
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-else class="loading">
            Loading...
        </div>
    </div>
</template>

<script>
import API from "@/API";

export default {
    name: "AddActivityTabContent",
    props: ['stage'],

    data(){
        return {
            is_ready: false,
            activities: [],
            filters: {
                q: '',
            }
        }
    },

    computed: {
        filtered_activities(){
            return this.activities.filter((activity) => {
                if( this.filters?.q?.length ){
                    const regex = new RegExp(this.filters.q, 'i');
                    if( !activity.name.match(regex) && !activity.data.description.match(regex) ){
                        return false;
                    }
                }

                if( this.stage?.length ){
                    if( !activity.groups.find( g => (g.name === this.stage && g.type === 'stage') ) ){
                        return false;
                    }
                }
                return true;
            });
        }
    },


    methods: {
        select(activity){
            this.$emit('selected', activity);
        },
    },


    async mounted() {
        this.is_ready = false;
        this.activities = await API.elements.bulk(_.extend(this.filters, {type: 'activity'}));
        this.is_ready = true;
    }

}
</script>

<style lang="scss" scoped>
.loading{
    padding: 6rem 1rem;
    text-align: center;
    color: lighten($dark, 15%);
}
.table{
    td, th{
        vertical-align: middle;
    }
}
</style>
